<template>
  <div id="CorcentricInvoicesExportList">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title"> Corcentric Invoices Extract List</div>
          <div  class="web-action-btn btn-groups text-right">
            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
              <i class="fp-export"></i> Export
            </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content corcentric-invoices-export-list">
            <section class="data-table bg-white">
              <custom-pagination
                :page-changed="onPageChange"
                :per-page-changed="onPerPageChange" :moduleName="'corcentricInvoicesExportList'" :position="'top'">
              </custom-pagination>
              <vue-good-table
                ref="listCorcentricInvoicesExportTable"
                mode="remote"
                title="Corcentric Invoices Export"
                @on-page-change="onPageChange"
                @on-selected-rows-change="selectionChanged"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                @on-sort-change="onSortChange"
                :totalRows="totalRecords"
                :columns="userColumns"
                :rows="rows"
                :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                :select-options="{
                                    enabled: group_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                :search-options="{
                                    enabled: false,
                                    }">

                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                  <div :key="key">
                    <div v-if="props.column.field == 'action'">
                      <router-link title="Edit Group" v-if="canUpdateGroup" class="fp-edit" v-bind:to="{name: 'GroupEdit',params:{id:props.row.id}}"></router-link>
                    </div>
                    <div v-else>
                      {{props.formattedRow[props.column.field]}}
                    </div>
                  </div>
                </template>

              </vue-good-table>
              <custom-pagination
                :page-changed="onPageChange"
                :per-page-changed="onPerPageChange">
              </custom-pagination>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>

import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

export default {
  name: "CorcentricInvoicesExportList",
  metaInfo() {
    return {title: "Corcentric Invoices Extract List | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins,dataTableMixins],
  data: () => ({
    firstLoad: 0,
    permissions: [],
    cantAccessPage: "",
    userColumns:[],
    columns: [
      /*
      The columns in BOA/ Enrich
        Affiliate
        Invoice Header Type
        Invoice Number
        Invoice Line Line Number
        Unit Number
        Customer Company
        Customer Number
        Customer Suffix
        Customer PO Number
        Customer Name
        Charge Type Code
        Charge Type Desc
        Invoice Line Qty
        Invoice Line Billable Hours
        Invoice Line Unit Price
        Invoice Line Labour Rate
        Invoice Line Extended Amount
        Invoice Line Tax Amount
        Invoice Line Source
        Source Doc Type
        Source Doc Number
        Source Doc Line
        VMRS Reason Code
        VMRS Reason Desc
        System Code
        System Desc
        Assembly Code
        Assembly Desc
        Component Code
        Component Desc
        Task Code
        Task Desc
        Agreement Header Type
        Agreement Number
        Agreement Unit Number
        Agreement Unit Assignment Date
        Contract Type
        Section Code
        Facility Code
        Billed From
        Billed To
        Reading From
        Reading To
        Charge Code
        Serial Number
        Unit Description
        Unit Year
        Unit Equipment Type
        Unit Make Code
        Unit Model Code
        Manual Charge Code
        Manual Charge Description
        Manual Charge PO Number
        Fuel Ticket Purchase Order Number
        Fuel Ticket Reference Number
        Total Invoiced Before Tax
        Total Invoiced
        Invoice Date
        Stock Part Number
        Item Description
        Item Type Code
        Xref
        Sub Agreement Number
        Substitute Unit Number
        Substitute Unit Serial Number
        Substitute Reason Code
        Fuel Ticket Date
        Fuel Ticket Mileage Reading
        Product
        Discount
        Cust Unit Number
        WO Mileage
        WO Complete Date
        Priority
        Priority Description
      * */

      {
        "label": "Affiliate",
        "field": "affiliate",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Invoice Header Type",
        "field": "invoice_header_type",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Invoice Number",
        "field": "inv_number",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Invoice Line Line Number",
        "field": "inv_line_number",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Unit Number",
        "field": "unit_number",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Customer Code",
        "field": "customer_code",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Customer PO Number",
        "field": "customer_po_number",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Customer Name",
        "field": "customer_name",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Charge Type Code",
        "field": "charge_type_code",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Charge Type Description",
        "field": "charge_type_desc",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Invoice Line Quantity",
        "field": "inv_line_qty",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Invoice Line Billable Hours",
        "field": "inv_line_billable_hours",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Invoice Line Unit Price",
        "field": "inv_line_unit_price",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Invoice Line Labour Rate",
        "field": "inv_line_labour_rate",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Invoice Line Extended Amount",
        "field": "inv_line_extended_amount",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Invoice Line Tax Amount",
        "field": "inv_line_tax_amount",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Invoice Line Source",
        "field": "inv_line_source",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Source Document Type",
        "field": "source_doc_type",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Source Document Number",
        "field": "source_doc_number",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Source Document Line",
        "field": "source_doc_line",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "VMRS Reason Code",
        "field": "vmrs_reason_code",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "VMRS Reason Description",
        "field": "vmrs_reason_desc",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "System Code",
        "field": "system_code",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "System Description",
        "field": "system_desc",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Assembly Code",
        "field": "assembly_code",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Assembly Description",
        "field": "assembly_desc",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Component Code",
        "field": "component_code",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Component Description",
        "field": "component_desc",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Task Code",
        "field": "task_code",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Task Description",
        "field": "task_desc",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Agreement Header Type",
        "field": "agreement_header_type",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Agreement Number",
        "field": "agreement_number",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Agreement Unit Number",
        "field": "agreement_unit_number",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Agreement Unit Assignment Date",
        "field": "agreement_unit_assignment_date",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Contract Type",
        "field": "contract_type",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Section Code",
        "field": "section_code",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Facility Code",
        "field": "facility_code",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Billed From",
        "field": "billed_from",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Billed To",
        "field": "billed_to",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Reading From",
        "field": "reading_from",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Reading To",
        "field": "reading_to",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Charge Code",
        "field": "charge_code",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Serial Number",
        "field": "serial_num",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Unit Description",
        "field": "unit_description",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Unit Year",
        "field": "unit_year",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Unit Equipment Type",
        "field": "unit_equipment_type",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Unit Make Code",
        "field": "unit_make_code",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Unit Model Code",
        "field": "unit_model_code",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Manual Charge Code",
        "field": "manual_charge_code",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Manual Charge Description",
        "field": "manual_charge_description",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Manual Charge PO Number",
        "field": "manual_charge_po_num",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "FT PO Number",
        "field": "ft_po_number",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "FT Reference Number",
        "field": "ft_reference_number",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Total Before Tax",
        "field": "total_before_tax",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Total Invoiced",
        "field": "total_invoiced",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Invoice Date",
        "field": "invoice_date",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Stock Part Number",
        "field": "stock_part_number",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Item Description",
        "field": "item_description",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Item Type Code",
        "field": "item_type_code",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Xref",
        "field": "xref",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Sub Agreement Number",
        "field": "sub_agreement_number",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Substitute Unit No",
        "field": "substitute_unit_no",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Substitute Serial Number",
        "field": "substitute_serial_number",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Substitute Reason Code",
        "field": "substitute_reason_code",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "FT Date",
        "field": "ft_date",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "FT Mileage Reading",
        "field": "ft_mileage_reading",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Product",
        "field": "product",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Discount",
        "field": "discount",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Cust Unit Number",
        "field": "cust_unit_number",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "WO Mileage",
        "field": "wo_mileage",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "WO Complete Date",
        "field": "wo_complete_date",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Priority",
        "field": "priority",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      },
      {
        "label": "Priority Desc",
        "field": "priority_desc",
        "filterable": false,
        "fpFieldType": "text",
        "hidden": false,
      }


    ],
    rows: [],
    totalRecords: 0,
    group_value: false,
    loading:false,
    canUpdateGroup:false,
    canAddGroup:false,
    action: ""
  }),
  created: function() {

  },
  watch:{
    //check permission change
    permissions: function (permissions) {
      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name == 'list_group') { // todo create permission for corecntric invoices export
            self.cantAccessPage = true;
          }
        }
      }

    }
  },
  mounted: function() {
    var self = this;

    //self.loadList();
    self.getPermissions();
  },
  methods: {
    exportCheck: function() {
      var count = 0;
      var actionFlag = "";
      var data = this.$refs['listCorcentricInvoicesExportTable'].selectedRows;
      count = data.length;
      if(this.serverParams.selectedAll == true){
        actionFlag = "";
      }else if(count != 0 && count <= 100){
        actionFlag = "export";
      }
      this.exportReports(actionFlag);
    },
    loadList() {
      console.log("Here I am");
      var self = this;
      self.loading = true;
      var fields = {
        page: self.serverParams.page,
        perPage: self.serverParams.perPage,
        filters: self.serverParams.columnFilters, // todo need to remove the filters, since it is not being used.
        // messageData: self.message,
        sort: self.serverParams.sort,
        all:self.serverParams.selectedAll,
        flag: self.action,
        // exportFiltered: self.exportFilteredFlag
      };
      self.firstLoad = 1;
      $.ajax({
        url: process.env.ROOT_API + "/invoice/corcentric/extract/list",
        type: "POST",
        data: fields,
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          // console.log(data);
          if (data.status == "success") {
            console.log("ACtions => ",self.action);
            self.rows = data.content.row;
            self.totalRecords = data.content.totalRecords;
            self.filteredFlag = false;
            if ( self.action == "export" ||  self.action == "export_queue") {
              if ( data.code == "201" ) {
                alert(data.message);
              } else {
                if ( self.action == "export" ) {
                  self.excel = data.content.web;
                  var save = document.createElement("a");
                  save.href = self.excel;
                  save.download = data.content.web;
                  save.target = "_blank";

                  document.body.appendChild(save);
                  save.click();
                  document.body.removeChild(save);

                } else {

                  self.batchProcess = 1;
                  self.batchNum = data.content;
                }
              }
              self.action = "";
              self.listFlag = "";
              self.loadList();
            }

          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR,false,'group-list')
        }
      });
    },
  }
};
</script>




// WEBPACK FOOTER //
// src/components/invoice/CorcentricInvoicesExtract.vue